/**
 * Rewrites a Supabase Storage public URL to use the on-the-fly image
 * transformer, serving a resized WebP. Non-Supabase URLs are returned as-is.
 *
 * Usage: <img src={optimizeImage(url, { width: 600 })} />
 */
export function optimizeImage(
  url: string | null | undefined,
  opts: { width?: number; height?: number; quality?: number; resize?: "cover" | "contain" | "fill" } = {}
): string {
  if (!url) return url ?? "";
  if (!url.includes("/storage/v1/object/public/")) return url;
  const transformed = url.replace(
    "/storage/v1/object/public/",
    "/storage/v1/render/image/public/"
  );
  const params = new URLSearchParams();
  if (opts.width) params.set("width", String(opts.width));
  if (opts.height) params.set("height", String(opts.height));
  params.set("quality", String(opts.quality ?? 75));
  if (opts.resize) {
    params.set("resize", opts.resize);
  }
  return `${transformed}?${params.toString()}`;
}
